









import { Component, Prop } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { tracking } from '@/lib/tracking';
import TrainingMenu from '@/components/TrainingMenu.vue';
import KBSearchInput from '@/components/kbSearchInput.vue'
import WeixinMixin from '../shared/weixin-mixin';
import { AbsCatalog } from '@/shared/catalog.model';

@Component({
  components: {
    'training-menu': TrainingMenu,
    'search-input': KBSearchInput,
  }
})
export default class Kb extends WeixinMixin {
  @Prop(String) readonly tabIndex!: string;
  @Prop(String) readonly catalogId!: string;

  showHome = true

  get categories(): Array<AbsCatalog> {
    return this.$store.state.catalogs;
  }

  get mode(): string {
    return this.currentCatalog?.title === '培训中心' ? 'headless' : 'head';
  }

  get lastlayout(): boolean {
    return this.currentCatalog?.title == '销售类培训';
  }

  get currentCatalog(): AbsCatalog | undefined {
    const tabIndex: number = parseInt(this.tabIndex);
    const catalogId: number = parseInt(this.catalogId);
    return this.categories[tabIndex]?.catalogs?.find(c => c.id === catalogId);
  }

  get catalogs(): Array<AbsCatalog> {
    return this.currentCatalog?.catalogs ?? [];
  }

  showPad (flag: boolean) {
    if (flag) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      (this.$refs.kbContainer as HTMLElement).style.overflow = 'hidden'
    } else {
      document.documentElement.style.overflow = 'auto';
      document.body.style.overflow = 'auto';
      (this.$refs.kbContainer as HTMLElement).style.overflow = 'auto'
    }
  }

  beforeRouteEnter(to: Route, from: Route, next: any) {
    next((vm: any) => {
      vm.showHome = false
    })
  }

  gotoKbSearch() {
    if (this.$refs.kbContainer && this.$refs.kbList && (this.$refs.kbContainer as HTMLElement).scrollTop) {
      sessionStorage.setItem('CACHE_SCROLL_BEFORE_KB_SEARCH', JSON.stringify({top: (this.$refs.kbContainer as HTMLElement).scrollTop, page: (this.$refs.kbList as any).page}))
    }
    this.$router.push(`/kb-search/${this.tabIndex}/${this.catalogId}`);
  }

  created() {
    tracking({ isAction: false, pageName: `KB_${this.tabIndex}_${this.catalogId}` })
  }

  mounted() {
    setTimeout(this.checkResult, 5000);
  }

  checkResult() {
    if (this.currentCatalog) {
      return;
    }
    this.$router.replace('/404');
  }
}
